import { frontendURL } from 'dashboard/helper/URLHelper';
import InternalInbox from './InternalInbox.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-inbox'),
    name: 'internal_inbox',
    component: InternalInbox,
    meta: { permissions: [...ROLES, ...CONVERSATION_PERMISSIONS] },
  },
];
